import { render, staticRenderFns } from "./InsCmsPhotoSwiper.vue?vue&type=template&id=18cc1ce0&scoped=true&"
import script from "./InsCmsPhotoSwiper.vue?vue&type=script&lang=ts&"
export * from "./InsCmsPhotoSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsPhotoSwiper.vue?vue&type=style&index=0&id=18cc1ce0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc1ce0",
  null
  
)

export default component.exports